module.exports = require('./FileLinkView');
